import { render, staticRenderFns } from "./bd-map.vue?vue&type=template&id=f8e12a8c"
import script from "./bd-map.vue?vue&type=script&lang=js"
export * from "./bd-map.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports